document.addEventListener("DOMContentLoaded", function () {
  const collapsables = document.querySelectorAll("[data-save-collapse-state]");
  collapsables.forEach(function (collapseElement) {
    if (!collapseElement.id) return;

    const storageKey = "collapse_state_" + collapseElement.id;
    const storedState = sessionStorage.getItem(storageKey);

    if (storedState === "hidden") {
      collapseElement.classList.remove("show");
      const buttons = document.querySelectorAll('[data-bs-target="#' + collapseElement.id + '"]');
      buttons.forEach(function (btn) {
        btn.setAttribute("aria-expanded", "false");
        btn.classList.add("collapsed");
      });
    } else if (storedState === "shown") {
      collapseElement.classList.add("show");
      const buttons = document.querySelectorAll('[data-bs-target="#' + collapseElement.id + '"]');
      buttons.forEach(function (btn) {
        btn.setAttribute("aria-expanded", "true");
        btn.classList.remove("collapsed");
      });
    }

    collapseElement.addEventListener("hidden.bs.collapse", function () {
      sessionStorage.setItem(storageKey, "hidden");
    });

    collapseElement.addEventListener("shown.bs.collapse", function () {
      sessionStorage.setItem(storageKey, "shown");
    });
  });
});
